import rpc from "@/rpc";

class LoanHistoryService {
    rpc

    constructor(rpc) {
        this.rpc = rpc
    }

    byEventTypes(eventTypes, limit = 50, offset = 0, filters = {}) {
        const cleanFilters = Object.fromEntries(
            Object.entries(filters).filter(([, v]) => v !== '' && v !== null && v !== undefined)
        );
        return this.rpc.execute('loanHistory.byEventTypes', {
            eventTypes: eventTypes,
            limit: limit,
            offset: offset,
            ...cleanFilters,
        });
    }

    latest({ loanId = null, cbUuid = null } = {}) {
        return this.rpc.execute('loanHistory.latest', {
            loanId: loanId ? parseInt(loanId) : null,
            cbUuid: cbUuid,
        });
    }

    list({ loanId = null, cbUuid = null, limit = 50 } = {}) {
        return this.rpc.execute('loanHistory.list', {
            loanId: loanId ? parseInt(loanId) : null,
            cbUuid: cbUuid,
            limit: limit,
        });
    }
}

export default new LoanHistoryService(rpc)
